import { Component, Prop, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import ordersStore from '@/store/orders';
import { Order, OrderLine } from '@/models';
import CardComponent from '@/components/CardComponent';
import CustomToolbar from '@/components/CustomToolbar';
import { DocumentStatus } from '@/types';

@Component({
   components: { CardComponent, CustomToolbar },
})
export default class OrderTransmitted extends Vue {

   // Injectectd from url
   @Prop({ default: '' }) private readonly id!: string;

   private selected: OrderLine | null = null;

   get loading(): boolean {
      return appStore.isLoading;
   }

   get order(): Order {
      return ordersStore.order || new Order();
   }

   get lines(): OrderLine[] {
      if (!this.order) return [];
      return this.order.lines || [];
   }

   get orderStatusDescription(): string {
      if (!this.order) return '';
      return this.order.statusDescription || appStore.documentStatus()(this.order.status).shortDescription;
   }

   get canRetransmit(): boolean {
      if (!this.order) return false;
      return this.order.status === DocumentStatus.Transmitting;
   }

   get canSync(): boolean {
      if (!this.order) return false;
      return (this.order.year === new Date().getFullYear() || this.order.year === (new Date().getFullYear() - 1)) &&
         (this.order.transmissionDate !== undefined && this.order.transmissionDate !== null);
   }

   private async created() {
      await ordersStore.fetchOrderAsync({ id: this.id });
   }

   private async mounted() {
      await appStore.activateMenuById({ rootId: 100, subMenuId: 103 });
   }

   private async sync() {

      this.$buefy.dialog.confirm({
         title: 'Sincronizzazione',
         message: 'Sei sicuro/a di voler <b>sincronizzare</b> l\'ordine corrente ?',
         confirmText: 'Conferma',
         cancelText: 'Annulla',
         type: 'is-warning',
         hasIcon: true,
         onConfirm: async () => await this.synchronizeOrderAsync(),
      });
   }

   private async print() {
      if (this.order) {
         await ordersStore.printOrderAsync({ id: this.id })
            .then((blob) => {
               if (!blob) {
                  return;
               }
               const url = URL.createObjectURL(new Blob([blob], {
                  type: 'application/pdf',
               }));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', `Ordine-${this.order.documentNumber}.pdf`);
               link.style.display = 'none';
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
            });

         // this.$nextTick(() => {
         //    window.print();
         // });
      }
   }

   private async synchronizeOrderAsync() {
      await ordersStore.syncOrderAsync({ id: this.id })
         .then(async () => {
            await ordersStore.fetchOrderAsync({ id: this.id });
         });
   }

   private async retransmit() {
      this.$buefy.dialog.confirm({
         title: 'Ri-Trasmissione',
         message: 'Sei sicuro/a di voler <b>ri-trasmettere</b> l\'ordine corrente ?',
         confirmText: 'Conferma',
         cancelText: 'Annulla',
         type: 'is-warning',
         hasIcon: true,
         onConfirm: async () => await this.retransmitOrderAsync(),
      });
   }

   private async retransmitOrderAsync() {
      await ordersStore.sendCartAsync({ id: this.id })
         .then(async () => {
            await ordersStore.fetchOrderAsync({ id: this.id });
         });
   }

   private goBack() {
      this.$router.go(-1);
   }

   private orderNumberYear(order: Order) {
      if (!order) { return ''; }
      return order.documentNumber + '/' + order.year;
   }
}
